import React from 'react'
import { Button, GlassMorphIcon } from '@/components/ui'
import type { IPublicationFinancingWidgetCollapsingAgentRegistrationStatusProps } from './types'
import './styles.scss'

export const AgentRegistrationStatus: React.FC<IPublicationFinancingWidgetCollapsingAgentRegistrationStatusProps> = props => {
  const { icon, title, subtitle, actionText, onAction, children } = props

  return (
    <div className="agentRegistrationStatus">
      {icon && <GlassMorphIcon className="agentRegistrationStatus__icon" image={icon} />}
      <h3 className="agentRegistrationStatus__title">{title}</h3>
      <div className="agentRegistrationStatus__subtitle">{subtitle}</div>
      <div className="agentRegistrationStatus__content">{children}</div>
      <div className="agentRegistrationStatus__actions">
        <Button modifiers={['green', 'full-width-mobile']} onClick={onAction}>
          {actionText}
        </Button>
      </div>
    </div>
  )
}
